import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from './auth.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService  {
  constructor(
    private _authService: AuthService,
    private _router: Router
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {

    // Verifica se há um token
    if (!this._authService.getToken()) {
      this.redirectToLogin();
      return of(false);
    }

    // Verifica a validade do token
    return this._authService.isTokenValid().pipe(
      map(isValid => {
        if (!isValid) {
          this.redirectToLogin();
          return false;
        }
        return true;
      }),
      catchError(() => {
        this.redirectToLogin();
        return of(false);
      })
    );
  }

  private redirectToLogin() {
    this._router.navigate(['/pages/login']);
    localStorage.clear();
    // Aqui você pode salvar a URL solicitada para redirecionar o usuário após o login, se necessário.
  }
}
